import { FormatType } from "../../Alert/Filter/FilterType";
import {
  ConfigurationFormType,
  ConfigurationPageTable,
  ConfigurationPageType,
  ConfigurationTableFilterType,
} from "../interfaces";
import { SURQUAL_SEGMENT_PAGE_SEGMENT_TAB } from "./SURQUAL_SEGMENT";

export const MAPPING_SEGMENT_PAGE: ConfigurationPageTable = {
  type: ConfigurationPageType.TABLE,
  label: "SEGMENT",
  menuLabel: "SEGMENT",
  pageLabel: "SEGMENT_TITLE_MAPPING",
  name: "mapping_segment",
  path: "segments",
  description: "CONF_DESC_MAPPING_SEGMENT",
  model: {
    entityName: "datafeed",
    label: "SEGMENT",
    path: "/api/mapping/segments",
    bulkPath: "/api/mapping/segments/bulk-updates",
    name: "Segment",
    attributes: [
      {
        key: "datafeed",
        order: 1,
        label: "DATA_FEED_CODE",
        visible: true,
      },
      {
        key: "connector",
        order: 2,
        label: "CONNECTOR_CODE",
        visible: true,
      },
      {
        key: "properties",
        order: 3,
        label: "PROPERTIES",
        sortable: false,
        type: FormatType.LIST,
        labelKey: "short_name",
        numberOfColumnItemsToDisplay: 2,
        tooltip: true,
        visible: true,
      },
      {
        key: "nb_uh_r12",
        className: "progressOcc",
        order: 4,
        label: "OCC_SOLD",
        sortingOrder: ["desc", "asc", null],
        type: FormatType.PROGRESS,
        visible: true,
      },
      {
        key: "turnover_r12",
        className: "progressCA",
        order: 5,
        label: "CA_SOLD",
        sortingOrder: ["desc", "asc", null],
        type: FormatType.PROGRESS_CURRENCY,
        visible: true,
      },
      {
        key: "pm_r12",
        className: "progressPM",
        order: 6,
        label: "PM_SOLD",
        sortingOrder: ["desc", "asc", null],
        type: FormatType.PROGRESS_CURRENCY,
        visible: true,
      },
      {
        key: "segment.code",
        order: 7,
        label: "SEGMENT",
        visible: true,
      },
    ],
    filters: [
      {
        type: ConfigurationTableFilterType.Unmapped,
        api: "/api/mapping/segments/?is_unmapped=true",
      },
      {
        type: ConfigurationTableFilterType.SelectMultiple,
        mustTranslateOptions: false,
        api: "/api/properties/",
        apiParams: {
          page_size: 100,
          ordering: "hebergement_nom_court",
        },
        key: "properties",
        labelKey: "hebergement_nom_court",
        label: "PROPERTIES",
        lookup: "property__in",
        controlledInputSize: true,
        numericIds: true,
      },
      {
        type: ConfigurationTableFilterType.Select,
        api: "/api/mapping/segments/connectors/",
        apiParams: {
          page_size: 100,
          ordering: "connector",
        },
        key: "id",
        labelKey: "id",
        label: "CONNECTOR_CODE",
        lookup: "connector",
        allowEmpty: true,
      },
      {
        type: ConfigurationTableFilterType.Search,
      },
      {
        type: ConfigurationTableFilterType.ResetButton,
      },
    ],
    export: { path: "/api/mapping/segments/export" },
    import: { path: "/api/mapping/segments/presign-url" },
  },
  options: {
    formFields: [
      {
        type: ConfigurationFormType.Input,
        key: "datafeed",
        label: "DATA_FEED_CODE",
      },
      {
        type: ConfigurationFormType.Input,
        key: "connector",
        label: "CONNECTOR_CODE",
      },
      {
        type: ConfigurationFormType.Select,
        api: "/api/segments/",
        apiParams: {
          page_size: 100,
          ordering: "code",
        },
        key: "segment",
        label: "SEGMENT",
        labelKey: "code",
        subCreationForm: SURQUAL_SEGMENT_PAGE_SEGMENT_TAB,
      },
    ],
    copyable: false,
    creatable: false,
    deletable: false,
    editable: true,
    editOptions: [
      {
        key: "datafeed",
        flex: "100%",
        readonly: true,
      },
      {
        key: "connector",
        flex: "100%",
        readonly: true,
      },
      {
        key: "segment",
        flex: "100%",
      },
    ],
    editSelectedOptions: [
      {
        key: "segment",
        flex: "100%",
      },
    ],
  },
};
